import React from "react";
import FinanzasDashboard from "../../components/admin/FinanzasDashboard";

/**
 * Página de Finanzas - Dashboard completo
 * Muestra ingresos, egresos, análisis de rentabilidad
 * Soporta vistas: mensual, trimestral (Q1-Q4), anual
 */
const Finanzas = () => {
  return <FinanzasDashboard />;
};

export default Finanzas;
